import { createSelector } from 'reselect';
import { questionnaireEvaluationDataSource } from './questionnaireEvaluationDataSource';
export const getQuestionnaireEvaluationQuestionList = (state) => questionnaireEvaluationDataSource(state).questionList;
export const getQuestionnaireEvaluationQuestionText = createSelector([getQuestionnaireEvaluationQuestionList], (questionList) => {
    return questionList.length ? questionList[0].qustnText : undefined;
});
export const getQuestionnaireEvaluationDocId = (state) => state.domain.questionnaireEvaluation.evaluationDocId;
export const getQuestionnaireEvaluationQuestionFormattedText = createSelector([getQuestionnaireEvaluationQuestionList], (questionList) => {
    return questionList.length ? questionList[0].qustnFormattedText : undefined;
});
export const getQuestionnaireEvaluationQuestionAttributeType = createSelector([getQuestionnaireEvaluationQuestionList], (questionList) => {
    return questionList.length ? questionList[0].questionAttributeType : '';
});
export const getQuestionnaireEvaluationQuestion = createSelector([getQuestionnaireEvaluationQuestionFormattedText, getQuestionnaireEvaluationQuestionText], (formattedQuestionText, questionText) => {
    if (formattedQuestionText && formattedQuestionText != 'false')
        return atob(formattedQuestionText);
    else {
        if (questionText)
            return questionText;
        else
            return '';
    }
});
export const getQuestionnaireEvaluationQuestionnaireQuestionId = createSelector([getQuestionnaireEvaluationQuestionList], (questionList) => {
    return questionList.length ? questionList[0].qustnnreQustnId : undefined;
});
export const getQuestionnaireEvaluationAnswerControlType = createSelector([getQuestionnaireEvaluationQuestionList], (questionList) => {
    return questionList.length ? questionList[0].answrControlType : null;
});
export const getQuestionnaireEvaluationAnswerDisplayText = createSelector([getQuestionnaireEvaluationQuestionList], (questionList) => (questionList.length && questionList[0].answerList && questionList[0].answerList[0].answerDisplayText) || '');
export const getQuestionnaireEvaluationQustnnrVrsnChng = createSelector([getQuestionnaireEvaluationQuestionList], (questionList) => (questionList.length && questionList[0].qustnnrVrsnChng) || false);
export const getQuestionnaireEvaluationAnswerList = createSelector([getQuestionnaireEvaluationQuestionList], (questionList) => (questionList.length && questionList[0].answerList) || []);
export const getQuestionnaireEvaluationParentQuestionId = createSelector([getQuestionnaireEvaluationQuestionList], (questionList) => {
    return questionList.length && questionList[0].parentQuestionId;
});
export const getIsQuestionnaireEvaluationMultiSelectAllowed = createSelector([getQuestionnaireEvaluationQuestionList], (questionList) => (questionList.length && questionList[0].multiSelectAllowed) || false);
export const getQuestionnaireEvaluationAnswered = createSelector([getQuestionnaireEvaluationQuestionList], (questionList) => (questionList.length &&
    questionList[0].answerList &&
    questionList[0].answerList.length &&
    questionList[0].answerList[0].answered) ||
    false);
export const getQuestionnaireEvaluationOptionalQuestion = createSelector([getQuestionnaireEvaluationQuestionList], (questionList) => (questionList.length && questionList[0].optionalQuestion) || false);
//# sourceMappingURL=getQuestionnaireEvaluationQuestionData.js.map